import { Component } from "react";
import PropTypes from "prop-types";
import getSenderIds from "../../services/senderIds";
import { HoverableRow, HoverableTd } from "../../styles/hoverableRow";

export default class IssueItem extends Component {
  static propTypes = {
    idx: PropTypes.number,
    updateIssue: PropTypes.func,
    id: PropTypes.string,
    shouldSend: PropTypes.bool,
    messageString: PropTypes.string,
    label: PropTypes.string,
    phonesString: PropTypes.string,
    emailsString: PropTypes.string,
    severity: PropTypes.number,
    // unused for some reason
    // lng: PropTypes.string,
    // msg: PropTypes.string,
    // params: PropTypes.any,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const lables = getSenderIds();
    if (!lables.includes(this.props.label)) {
      console.warn("wrong label name:", this.props.label);
      const { idx, updateIssue } = this.props;
      updateIssue(idx, "label", lables[0]);
    }
  }

  onChangeSendStatus = () => {
    const { idx, shouldSend, updateIssue } = this.props;
    updateIssue(idx, "shouldSend", !shouldSend);
  };

  onChangeSendCustom = () => {
    const { idx, sendCustom, updateIssue } = this.props;
    updateIssue(idx, "sendCustom", !sendCustom);
  };

  onChangeLabel = (ev) => {
    const { idx, updateIssue } = this.props;
    updateIssue(idx, "label", ev.target.value);
  };

  onChangePhones = (ev) => {
    const { idx, updateIssue } = this.props;
    updateIssue(idx, "phonesString", ev.target.value);
  };

  onChangeEmails = (ev) => {
    const { idx, updateIssue } = this.props;
    updateIssue(idx, "emailsString", ev.target.value);
  };

  onCopyMessage = () => {
    navigator.clipboard.writeText(this.props.messageString);
  };

  onChangeStatus = (ev) => {
    const { idx, updateIssue, issueData } = this.props;
    const newStatus = issueData[ev.target.value];
    const { updateKeys, updateValues } = [
      ["status", newStatus.status],
      ...Object.entries(newStatus.data),
    ].reduce(
      ({ updateKeys, updateValues }, [key, val]) => {
        updateKeys.push(key);
        updateValues.push(val);
        return { updateKeys, updateValues };
      },
      { updateKeys: [], updateValues: [] }
    );
    updateIssue(idx, updateKeys, updateValues, true);
  };

  render() {
    const {
      id,
      shouldSend,
      messageString,
      label,
      phonesString,
      emailsString,
      sent,
      severity,
      thresholdSeverity,
      issueData,
      disabled,
      issueKey,
      sysHealth,
      customList,
      sendCustom,
      showCustom,
    } = this.props;
    const allowCustomChange = Array.isArray(customList) && customList.length;
    const customPhones = !allowCustomChange
      ? ""
      : customList.map(({ recipient }) => recipient).join("\n");
    let abbr_issue = issueKey.startsWith("f-")
      ? issueKey.slice(2)
      : issueKey.startsWith("if-")
      ? issueKey.slice(3)
      : issueKey;
    abbr_issue = abbr_issue.endsWith("-n")
      ? abbr_issue.slice(0, -2)
      : abbr_issue;

    const currentIssueIdx = issueData.findIndex(
      ({ status }) => status === this.props.status
    );
    return (
      <HoverableRow>
        {/* should send */}
        <HoverableTd>
          <input
            type="checkbox"
            disabled={disabled || severity <= thresholdSeverity}
            checked={shouldSend}
            onChange={this.onChangeSendStatus}
          />
        </HoverableTd>
        {/* sys id */}
        <HoverableTd>{id}</HoverableTd>
        {/* sys health */}
        <HoverableTd>{sysHealth}</HoverableTd>
        {/* translated message, copy on press */}
        <HoverableTd
          title={messageString}
          onClick={this.onCopyMessage}
          style={{ cursor: "pointer" }}
          shouldClampLines={true}
        >
          {messageString}
        </HoverableTd>
        {/* issue code */}
        <HoverableTd>{abbr_issue}</HoverableTd>
        {/* status */}
        <HoverableTd>
          <select
            disabled={disabled}
            value={currentIssueIdx}
            onChange={this.onChangeStatus}
          >
            {issueData.map((data, idx) => (
              <option key={idx} value={idx}>
                {data.data.severity} - {data.status}
              </option>
            ))}
          </select>
        </HoverableTd>
        {/* label */}
        <HoverableTd>
          <select
            disabled={disabled}
            value={label}
            onChange={this.onChangeLabel}
          >
            {getSenderIds().map((sender, idx) => (
              <option key={idx}>{sender}</option>
            ))}
          </select>
        </HoverableTd>
        {!showCustom ? null : (
          <HoverableTd>
            <input
              type="checkbox"
              title={customPhones}
              disabled={
                disabled || severity <= thresholdSeverity || !allowCustomChange
              }
              checked={sendCustom}
              onChange={this.onChangeSendCustom}
            />
          </HoverableTd>
        )}
        {/* phones */}
        <HoverableTd>
          <input
            type="tel"
            size="30"
            value={phonesString}
            onChange={this.onChangePhones}
            disabled={disabled || !shouldSend}
          />
        </HoverableTd>
        {/* emails */}
        <HoverableTd>
          <input
            type="email"
            size="30"
            value={emailsString}
            onChange={this.onChangeEmails}
            disabled={disabled || !shouldSend}
          />
        </HoverableTd>
        {/* sent indicator */}
        <HoverableTd>{sent ? "sent" : " "}</HoverableTd>
      </HoverableRow>
    );
  }
}
